import { FeatureFlag, useFeatureFlag } from "../contexts/launchDarklyContext";

/**
 * Whether the Optro bulk-import flow (the import wizard and its entry cards)
 * is enabled for the current user/workspace.
 *
 * Single source of truth for every bulk-import surface — the entry cards,
 * the create-control chooser, and the wizard route guard — so they can't
 * drift out of sync. The backend gates the wizard's endpoints on the same
 * `optro-bulk-import` LaunchDarkly flag.
 *
 * Fails closed (off) until flags resolve or when LaunchDarkly is
 * unconfigured. Targeting is managed in the LaunchDarkly dashboard.
 */
export function useOptroBulkImportEnabled(): boolean {
  return useFeatureFlag(FeatureFlag.optroBulkImport);
}
